import React,{Component, PropTypes} from 'react';
import Avatar from 'material-ui/Avatar';
import TextField from 'material-ui/TextField'
import {Card, CardHeader, CardText,CardActions} from 'material-ui/Card';
import FlatButton from 'material-ui/FlatButton'
import Dialog from 'material-ui/Dialog'
import BoltInfo from './BoltInfo'
import TickInfo from './TickInfo'
import RouteDetail from './RouteDetail'
import CommentList from './CommentList'
import locale from '../locale'
import {addTag,deleteTag,saveComment,getAuth,login} from '../actions'
import {GradeColors} from '../config'
import {StyleColors} from '../config'

const styles = {
  detail: {
    marginLeft:56,
    paddingTop:0,
  },
  actions: {
    backgroundColor:'#88888830'

  }
}

const RouteAvatar = ({id,style})=>{
  // let {grade,id,style} = route
  // grade = grade.split('\/')[0].replace(/a|b|c|d/g,'')
  // let backgroundColor = GradeColors[grade] ||'#CCC'
  let backgroundColor = style.includes('運動') ? StyleColors.Sport : StyleColors.Trad
  return <Avatar backgroundColor={backgroundColor}>{id}</Avatar>
}


export default class RouteCard extends Component {

  constructor(props) {
    super(props)
    this.state = {
      expanded: false,
      open:false,
    }
  }

  static contextTypes = {
    store: PropTypes.object.isRequired,
  };


  handleExpandChange(expanded) {
    if(this.props.onClick)
      this.props.onClick()
    else
      this.setState({expanded: expanded});
  }

  isLogin(){
    if(getAuth())
      return true
    else{
      this.context.store.dispatch(login())
    }
  }

  handleClose = () => {
    this.setState({open: false,comment:''});
  }

  handleOpen = () => {
    if(!this.isLogin())
      return

    this.setState({open: true});
  }

  handleSubmit = () => {
    let {route:{id:routeId}}=this.props
    let {me:{uid,name,fbid}} = this.context.store.getState()
    let {text:context} = this.state
    let comment = {
      routeId,
      uid,
      fbid,
      name,
      context,
    }
    saveComment(comment)
    console.log('comment',comment)
    this.handleClose()
  }

  handleChange = (event) => {
    this.setState({
      text: event.target.value,
    });
  };


  toggleTick = () => {
    if(!this.isLogin())
      return

    let {route:{id:routeId,isTick}} = this.props
    let {me:{fbid}} = this.context.store.getState()

    let tag = {
      key:'TICK',
      routeId,
      fbid,
    }
    isTick ? deleteTag(tag) : addTag(tag)
  }

  render() {
    let {route} = this.props
    let {expanded,text} = this.state
    expanded = expanded || this.props.expanded
    let {id,name,nameEN,grade,length,style,comments,tickList,isTick} = route
    let title = name
    nameEN && (name !== nameEN) && (title+= ' '+nameEN)
    title += ' '+grade
    let subtitle = locale.get(style)
    length && (subtitle += ' · '+length+'m')
    let commentList = comments && Object.keys(comments).map(key=>comments[key]).reverse()
    let cardStyle = this.state.expanded ? {marginTop:16,marginBottom:16} : undefined
    let tickLabel = isTick ? locale.R.MarkNotTick : locale.R.MarkTick
    const actions = [
      <FlatButton
        label={locale.R.cancel}
        primary={true}
        onTouchTap={this.handleClose}
      />,
      <FlatButton
        label={locale.R.submit}
        primary={true}
        disabled={!text}
        onTouchTap={this.handleSubmit}
      />,
    ];

    return (
      <Card style={cardStyle} expanded={expanded} onExpandChange={this.handleExpandChange.bind(this)}>
        <CardHeader
          title={title}
          subtitle={subtitle}
          avatar={RouteAvatar(route)}
          actAsExpander={true}
          showExpandableButton={true}
        />
        <CardText expandable={true} style={styles.detail}>
          <RouteDetail route={route} />
          <BoltInfo route={route}/>
          {tickList && <TickInfo list={tickList}/>}
          {commentList && <CommentList list={commentList}/>}
        </CardText>
        <CardActions expandable={true} style={styles.actions}>
          <FlatButton label={tickLabel} onTouchTap={this.toggleTick}/>
          <FlatButton label={locale.R.Comment} onTouchTap={this.handleOpen}/>
        </CardActions>

        <Dialog
          actions={actions}
          modal={false}
          open={this.state.open}
          onRequestClose={this.handleClose}>
          <TextField
            id="newComment"
            floatingLabelText={locale.R.AddComment}
            fullWidth={true}
            multiLine={true}
            onChange={this.handleChange}
            rows={4}/>
        </Dialog>

      </Card>
    )
  }
}



/** WEBPACK FOOTER **
 ** ./src/app/components/RouteCard.js
 **/